export default "__VITE_ASSET__DS$1b1_5__"